const DashboardSneakPeek = () => {
  return (
    <section className="py-20 sm:py-32 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
            Join the Waiting List & Affiliate Program
          </h2>
          <p className="mt-4 text-lg text-gray-400">
            Get a glimpse of the powerful tools at your fingertips and join our mission to empower the music community.
          </p>
        </div>

        <div className="mt-16 max-w-5xl mx-auto">
          <div className="bg-white/5 p-8 rounded-2xl">
            <h3 className="text-2xl font-bold text-center">Dashboard Sneak Peek</h3>
            <p className="mt-2 text-gray-400 text-center">
              A centralized hub for creators, groovers, and venues to manage their world.
            </p>
            <div className="mt-6 rounded-xl overflow-hidden border border-white/10 aspect-video">
              <video
                src="/videos/dashboard-preview.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardSneakPeek;
